import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { InputText } from 'primeng/inputtext';

@Component({
    selector: 'app-filiacao',
    standalone: true,
    imports: [ReactiveFormsModule, InputText],
    templateUrl: './filiacao.html',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    changeDetection: ChangeDetectionStrategy.OnPush
})
/** Seção de formulário de filiação (pai/mãe). */
export class FiliacaoComponent {
    modoEdicao = input<boolean>(false);
}
